/**
 * DISTRIBUTION-MAP MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point for the distribution-map module. The app composition root imports
// ONLY from here; nothing deep-imports this module's internals.
import Dashboard from "./routes/Dashboard.jsx";
import MapEditor from "./routes/MapEditor.jsx";

// `/distribution-map` was `/dashboard` until 2026-07-31 — a leftover from when
// this module WAS the whole product and its list screen was the app's dashboard.
// After the modular refactor `/` became the operations hub, which made
// "/dashboard" point at something that is no longer a dashboard. The old path
// still resolves: App.jsx redirects it here so existing bookmarks survive.
export const distributionMapRoutes = [
  { path: "/distribution-map", component: Dashboard },
  { path: "/maps/:mapId", component: MapEditor },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "distribution-map", label: "Distribution Map" };
